<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <div class="page-wrapper sales-list">
    <div class="content">
      <div v-if="isLoading" class="page-loading-overlay">
        <div class="spinner-border text-primary dashboard-spinner" role="status">
          <span class="visually-hidden">Chargement...</span>
        </div>
      </div>
      <div class="page-header">
        <div class="add-item d-flex">
          <div class="page-title">
            <h4>List des Factures</h4>
            <h6>Gérer vos Factures</h6>
          </div>
        </div>
        <ul class="table-top-head">
          <li>
            <a
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Pdf"
              @click.prevent="exportPDF"
            >
              <img src="@/assets/img/icons/pdf.svg" alt="img" />
            </a>
          </li>
          <li>
            <a
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Excel"
              @click.prevent="exportCSV"
            >
              <img src="@/assets/img/icons/excel.svg" alt="img" />
            </a>
          </li>
          <li>
            <a
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Print"
              @click.prevent="printTable"
            >
              <vue-feather type="printer" class="printer"></vue-feather>
            </a>
          </li>
          <li>
            <a
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Refresh"
              @click.prevent="refreshList"
            >
              <vue-feather type="rotate-ccw" class="rotate-ccw"></vue-feather>
            </a>
          </li>
          <li>
            <a
              ref="collapseHeader"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              title="Collapse"
              @click="toggleCollapse"
            >
              <i data-feather="chevron-up" class="feather-chevron-up"></i>
            </a>
          </li>
        </ul>
        <div class="page-btn">
          <a
            href="javascript:void(0);"
            class="btn btn-added"
            data-bs-toggle="modal"
            data-bs-target="#add-sales-new"
            ><vue-feather type="plus-circle" class="me-2"></vue-feather> Ajouter
            une nouvelle Facture</a
          >
        </div>
      </div>

      <!-- /product list -->
      <div class="card table-list-card">
        <div class="card-body">
          <div class="table-top">
            <div class="search-set">
              <div class="search-input">
                <input
                  type="text"
                  placeholder="Recherche"
                  class="dark-input"
                  v-model="searchQuery"
                  @input="applyFilters"
                  @keyup.enter="applyFilters"
                />
                <a href="" class="btn btn-searchset" @click.prevent="applyFilters"
                  ><i data-feather="search" class="feather-search"></i
                ></a>
              </div>
            </div>
          </div>
          <!-- /Filter -->
          <!-- Filters removed, search only -->
          <div class="table-responsive">
            <a-table :columns="columns" :data-source="filteredData" :row-selection="{}">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'Status'">
                  <div>
                    <span :class="record.Status_class">{{
                      record.Status
                    }}</span>
                  </div>
                </template>
                <template v-else-if="column.key === 'Payment_Status'">
                  <div>
                    <span :class="record.Payment_Class">{{
                      record.Payment_Status
                    }}</span>
                  </div>
                </template>
                <template v-else-if="column.key === 'declare'">
                  <div>
                    <template v-if="isAdmin">
                      <select
                        class="form-select form-select-sm declare-select"
                        :value="record.declare ? 'true' : 'false'"
                        :disabled="record.declare || declareLoading[record.id]"
                        @change="onDeclareChange(record, $event)"
                      >
                        <option value="false">Non déclarée</option>
                        <option value="true">Déclarée</option>
                      </select>
                    </template>
                    <template v-else>
                      <span :class="record.declare_class">{{ record.declare_label }}</span>
                    </template>
                  </div>
                </template>
                <template v-else-if="column.key === 'action'">
                  <td class="action-table-data">
                    <div class="edit-delete-action">
                      <a
                        class="me-2 edit-icon p-2"
                        href="javascript:void(0);"
                        @click="viewFacture(record)"
                        title="Voir facture"
                      >
                        <i data-feather="eye" class="feather-eye"></i>
                      </a>
                      <a
                        class="me-2 p-2"
                        href="javascript:void(0);"
                        data-bs-toggle="modal"
                        data-bs-target="#edit-sales-new"
                        @click="openEditModal(record)"
                      >
                        <i data-feather="edit" class="feather-edit"></i>
                      </a>
                      <a
                        class="me-2 p-2"
                        href="javascript:void(0);"
                        @click="handlePdf(record)"
                        ><vue-feather
                          type="download"
                          class="info-img"
                        ></vue-feather
                      ></a>
                      <a
                        class="confirm-text p-2"
                        @click="
                          showConfirmation(
                            record.id,
                            record.devis_id,
                            record.commande_id
                          )
                        "
                        href="javascript:void(0);"
                      >
                        <vue-feather
                          type="trash-2"
                          class="trash-2"
                        ></vue-feather>
                      </a>
                    </div>
                  </td>
                  <!-- <div class="text-center">
                    <a
                      class="action-set"
                      href="javascript:void(0);"
                      data-bs-toggle="dropdown"
                      aria-expanded="true"
                    >
                      <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                    </a>
                    <ul class="dropdown-menu sales-list-icon">
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#sales-details-new"
                          ><vue-feather
                            type="eye"
                            class="info-img"
                          ></vue-feather
                          >Sale Detail</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-sales-new"
                          ><vue-feather
                            type="edit"
                            class="info-img"
                          ></vue-feather
                          >Edit Sale</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#showpayment"
                          ><vue-feather
                            type="dollar-sign"
                            class="info-img"
                          ></vue-feather
                          >Show Payments</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="dropdown-item"
                          data-bs-toggle="modal"
                          data-bs-target="#createpayment"
                          ><vue-feather
                            type="plus-circle"
                            class="info-img"
                          ></vue-feather
                          >Create Payment</a
                        >
                      </li>
                      <li>
                        <a href="javascript:void(0);" class="dropdown-item"
                          ><vue-feather
                            type="download"
                            class="info-img"
                          ></vue-feather
                          >Download pdf</a
                        >
                      </li>
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="dropdown-item confirm-text mb-0"
                          ><vue-feather
                            type="trash-2"
                            class="info-img"
                          ></vue-feather
                          >Delete Sale</a
                        >
                      </li>
                    </ul>
                  </div> -->
                </template>
              </template>
            </a-table>
          </div>
        </div>
      </div>
      <!-- /product list -->
    </div>
  </div>

  <invoices-list-modal
    @facture-added="onFactureAdded"
    @edit-added="onFactureUpdated"
    :data="selectedDevis"
  ></invoices-list-modal>

  <!-- View facture modal -->
  <div class="modal fade" id="facture-view-modal" tabindex="-1" aria-hidden="true" ref="viewModalEl">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Détail de la facture</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body" v-if="selectedFacture">
          <div class="border rounded p-3 mb-3 bg-light">
            <div class="d-flex flex-wrap align-items-center gap-2">
              <span class="badge bg-primary text-uppercase">Facture {{ selectedFacture.numero_facture || "—" }}</span>
              <span class="badge bg-secondary">{{ formatDate(selectedFacture.date_creation || selectedFacture.CreatedOn) }}</span>
              <span :class="`badge ${statusBadge(selectedFacture.statut_paiement)}`">{{ statusLabel(selectedFacture.statut_paiement) }}</span>
              <span :class="`badge ${selectedFacture.declare ? 'bg-success' : 'bg-warning text-dark'}`">
                {{ selectedFacture.declare ? "Déclarée" : "Non déclarée" }}
              </span>
            </div>
          </div>

          <div class="row g-3">
            <div class="col-md-6">
              <div class="border rounded p-3 h-100">
                <h6 class="mb-2 text-muted">Client</h6>
                <div class="fw-semibold">{{ selectedFacture.client_nom || "—" }}</div>
                <div class="small text-muted">{{ selectedFacture.mode_paiement || "" }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="border rounded p-3 h-100">
                <h6 class="mb-2 text-muted">Montants</h6>
                <div class="d-flex justify-content-between">
                  <span>Total HT</span>
                  <span class="fw-semibold">{{ formatAmount(selectedFacture.montant_taxe) }}</span>
                </div>
                <div class="d-flex justify-content-between">
                  <span>Total TTC</span>
                  <span class="fw-semibold">{{ formatAmount(selectedFacture.montant_total) }}</span>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="border rounded p-3">
                <h6 class="mb-2 text-muted">Notes</h6>
                <div>{{ selectedFacture.notes || "—" }}</div>
              </div>
            </div>
          </div>

          <div v-if="selectedFacturePdfUrl" class="mt-3">
            <div class="mb-2 fw-semibold">Fichier signé / cachet</div>
            <div v-if="isPdfFile(selectedFacturePdfUrl)">
              <iframe
                :src="selectedFacturePdfUrl"
                class="w-100"
                style="min-height: 480px; border: 1px solid #e5e5e5; border-radius: 4px;"
              ></iframe>
            </div>
            <div v-else>
              <img
                :src="selectedFacturePdfUrl"
                alt="Fichier signé"
                class="img-fluid rounded border"
              />
            </div>
            <div class="mt-2">
              <a :href="selectedFacturePdfUrl" target="_blank" rel="noopener" class="btn btn-primary btn-sm">
                Ouvrir dans un nouvel onglet
              </a>
            </div>
          </div>
          <div v-else class="alert alert-info py-2 mt-3">
            Aucun fichier signé n'est associé à cette facture.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getFacturesData as fetchFacturesData, deleteFacture, updateFactureDeclare } from "@/services/facturesService";
import { getClientsData } from "@/services/clientsService";
import { generateCommandPdf } from "@/services/pdfService";
import { getCompanyData, getCompanyLogoDataUrl } from "@/services/companyService";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { getLignesCommandeDataByCommandeId } from "@/services/devisService";
import { toast } from "vue3-toastify";
import Swal from "sweetalert2";
import { getCurrentUser } from "@/services/authService";

const columns = [
  {
    sorter: true,
  },
  {
    title: "Référence du facture",
    dataIndex: "numero_facture",
    sorter: {
      compare: (a, b) => String(a?.numero_facture || "").localeCompare(String(b?.numero_facture || ""), "fr", { sensitivity: "base" }),
    },
  },
  {
    title: "Nom Client",
    dataIndex: "client_nom",
    sorter: {
      compare: (a, b) => String(a?.client_nom || "").localeCompare(String(b?.client_nom || ""), "fr", { sensitivity: "base" }),
    },
  },
  {
    title: "Date",
    dataIndex: "CreatedOn",
    sorter: {
      compare: (a, b) => {
        const pa = (v) => (v ? new Date(v).getTime() || 0 : 0);
        const va = pa(a?.date_creation || a?.CreatedOn);
        const vb = pa(b?.date_creation || b?.CreatedOn);
        return va - vb;
      },
    },
  },
  {
    title: "Statut",
    dataIndex: "Payment_Status",
    key: "Payment_Status",
    sorter: {
      compare: (a, b) => String(a?.Payment_Raw || "").localeCompare(String(b?.Payment_Raw || ""), "fr", { sensitivity: "base" }),
    },
  },
  {
    title: "Déclarée",
    dataIndex: "declare_label",
    key: "declare",
    sorter: {
      compare: (a, b) => (a?.declare ? 1 : 0) - (b?.declare ? 1 : 0),
    },
  },
  {
    title: "Totale du Commande",
    dataIndex: "montant_total",
    sorter: {
      compare: (a, b) => (Number(a?.montant_total) || 0) - (Number(b?.montant_total) || 0),
    },
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];

const data = [];
const clientData = [];
const clientIds = [];
const clients = [];
export default {
  data() {
    return {
      searchQuery: "",
      filteredData: [],
      columns,
      data,
      selectedDevis: {},
      selectedFacture: null,
      selectedFacturePdfUrl: null,
      viewModal: null,
      clientData,
      clientIds,
      company: {},
      clients,
      currentUser: null,
      isAdmin: false,
      declareLoading: {},
      isLoading: false,
    };
  },
  methods: {
    normalize(str) {
      return String(str ?? '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, ''); // strip diacritics
    },
    applyFilters() {
      const q = this.normalize(this.searchQuery || '').trim();
      if (!q) {
        this.filteredData = [...this.data];
        return;
      }
      this.filteredData = this.data.filter((r) => {
        const fields = [
          r.numero_facture,
          r.client_nom,
          r.Payment_Status || r.statut_paiement,
          r.mode_paiement,
          r.montant_total,
          r.CreatedOn,
          r.date_creation,
          r.declare_label,
        ];
        return fields
          .filter((v) => v !== undefined && v !== null)
          .map((v) => this.normalize(v))
          .some((v) => v.includes(q));
      });
    },
    showConfirmation(id_facture, id_devis, id_commandes) {
      Swal.fire({
        title: "Es-tu sûr de vouloir supprimer ce Devis ?",
        text: "Cette action est irréversible !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprime-le !",
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-danger ml-1",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            await deleteFacture(id_facture, id_devis, id_commandes);

            // Refresh list so table reflects server state
            await this.getFacturesData();
            this.applyFilters();
            Swal.fire({
              icon: "success",
              title: "Supprimé!",
              text: "Votre facture a été supprimée.",
              confirmButtonClass: "btn btn-success",
            });
          } catch (error) {
            console.error(error);
            const msg =
              error?.response?.data?.error ||
              error?.response?.data?.message ||
              error?.message ||
              "Une erreur est survenue";
            toast.error(msg);
          }
        }
      });
    },
    toggleCollapse() {
      const collapseHeader = this.$refs.collapseHeader;

      if (collapseHeader) {
        collapseHeader.classList.toggle("active");
        document.body.classList.toggle("header-collapse");
      }
    },
    setDeclareLoading(id, value) {
      this.declareLoading = { ...this.declareLoading, [id]: value };
    },
    async onDeclareChange(record, event) {
      const selectEl = event.target;
      const desired = selectEl.value === "true";

      if (record.declare && !desired) {
        // Not allowed to revert to false, reset select to true
        selectEl.value = "true";
        return;
      }

      if (record.declare === desired) {
        return;
      }

      this.setDeclareLoading(record.id, true);
      try {
        await updateFactureDeclare(record.id, true);
        record.declare = true;
        record.declare_label = "Déclarée";
        record.declare_class = "badges bg-lightgreen";
        const original = this.data.find((item) => item.id === record.id);
        if (original) {
          original.declare = record.declare;
          original.declare_label = record.declare_label;
          original.declare_class = record.declare_class;
        }
        selectEl.value = "true";
        toast.success("Facture marquée comme déclarée.");
      } catch (error) {
        const msg =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message ||
          "Impossible de mettre à jour le statut de déclaration.";
        toast.error(msg);
        selectEl.value = record.declare ? "true" : "false";
      } finally {
        this.setDeclareLoading(record.id, false);
        this.applyFilters();
      }
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return new Intl.DateTimeFormat("fr-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(date);
    },
    async getClientsData() {
      this.clientData = [];
      this.clientIds = [];
      try {
        const data = await getClientsData();
        data.map((m) => {
          const displayName = (m.nom_societe && m.nom_societe.trim())
            ? m.nom_societe
            : [m.prenom, m.nom].filter(Boolean).join(' ').trim();
          this.clientData.push(displayName);
          this.clients.push(m);
          this.clientIds.push(m.id);
        });
      } catch (error) {
        console.error(error);
        const msg =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          "Une erreur est survenue";
        toast.error(msg);
      }
    },
    getClientID(option) {
      let index = this.clientData.indexOf(option);
      if (index != -1) {
        return this.clientIds[index];
      }
      return index;
    },
    getClientName(id) {
      let index = this.clientIds.indexOf(id);
      if (index != -1) {
        return this.clientData[index];
      }
      return index;
    },
    findClient(id) {
      let index = this.clientIds.indexOf(id);
      if (index != -1) {
        return this.clients[index];
      }
      return index;
    },
    // async getDevisData() {
    //   this.data = [];
    //   try {
    //     const data = await getDevisData();
    //     data.map((m) => {
    //       this.data.push({
    //         id: m.id,
    //         statut: m.statut,
    //         commande_id: m.commande_id,
    //         numero_devis: m.numero_devis,
    //         valide_jusqua: m.valide_jusqua,
    //         notes: m.notes,
    //         commande: m.commande,
    //         societe_id: m.societe_id,
    //         mode_paiement: m.commande.mode_paiement,
    //         montant_total: m.commande.montant_total,
    //         montant_taxe: m.commande.montant_taxe,
    //         client_nom: this.getClientName(1),
    //         client_id: m.commande.client_id,
    //         CreatedOn: this.formatDate(m.created_at),
    //       });
    //     });
    //   } catch (error) {
    //     console.error(error);
    //     toast.error(error.response.data.message);
    //   }
    // },
    async onFactureAdded() {
      Swal.fire({
        icon: "success",
        title: "Succès",
        text: "Facture créé avec succès.",
        confirmButtonClass: "btn btn-success",
      });
      this.getFacturesData();
    },
    async onFactureUpdated() {
      Swal.fire({
        icon: "success",
        title: "Succès",
        text: "Facture modifiée avec succès.",
        confirmButtonClass: "btn btn-success",
      });
      this.getFacturesData();
    },
    async openViewModal() {
      const { Modal } = await import("bootstrap");
      if (!this.viewModal && this.$refs.viewModalEl) {
        this.viewModal = new Modal(this.$refs.viewModalEl, { backdrop: "static" });
      }
      this.viewModal?.show();
    },
    viewFacture(record) {
      this.selectedFacture = record;
      const baseUrl = process.env.VUE_APP_URL || window.location.origin;
      this.selectedFacturePdfUrl = record.pdf ? `${baseUrl.replace(/\/$/, "")}/storage/${record.pdf}` : null;
      this.openViewModal();
    },
    isPdfFile(url) {
      return /\.pdf(?:$|\?)/i.test(String(url || ""));
    },
    formatAmount(value) {
      const num = Number(value);
      return Number.isFinite(num) ? num.toFixed(2) : "—";
    },

    async getFacturesData() {
      this.isLoading = true;
      this.data = [];
      try {
        const data = await fetchFacturesData();
        (Array.isArray(data) ? data : []).map((m) => {
          const rawPay = String(m.statut_paiement || '').toUpperCase();
          const isDeclared = Boolean(m.declare);
          this.data.push({
            id: m.id,
            statut_paiement: m.statut_paiement,
            Payment_Raw: rawPay,
            Payment_Status: this.statusLabel(rawPay),
            Payment_Class: this.statusBadge(rawPay),
            commande_id: m.commande_id,
            devis_id: m.devis_id || m.commande?.devis_id || null,
            numero_facture: m.numero_facture,
            notes: m.commande?.notes || "",
            commande: m.commande || null,
            pdf: m.pdf || null,
            date_creation: m.date_creation,
            societe_id: m.societe_id,
            mode_paiement: m.commande?.mode_paiement || "",
            montant_total: m.commande?.montant_total ?? null,
            montant_taxe: m.commande?.montant_taxe ?? null,
            montant_payé: m.commande?.montant_payé ?? null,
            montant_restant: m.commande?.montant_restant ?? null,
            client_nom: m.client_name || this.getClientName(m.commande?.client_id),
            client_id: m.commande?.client_id ?? null,
            CreatedOn: this.formatDate(m.created_at),
            declare: isDeclared,
            declare_label: isDeclared ? "Déclarée" : "Non déclarée",
            declare_class: isDeclared ? "badges bg-lightgreen" : "badges bg-lightred",
          });
        });
        this.filteredData = [...this.data];
      } catch (error) {
        console.error(error);
        const msg =
          error?.response?.data?.error ||
          error?.response?.data?.message ||
          error?.message ||
          "Une erreur est survenue";
        toast.error(msg);
      } finally {
        this.isLoading = false;
      }
    },

    // Map payment status to badge class
    statusBadge(status) {
      const s = String(status || "").toUpperCase();
      switch (s) {
        case "PAYÉ":
          return "badges bg-lightgreen"; // green
        case "IMPAYÉ":
          return "badges bg-lightred"; // red
        case "PARTIELLEMENT_PAYÉ":
          return "badges bg-lightyellow"; // yellow
        case "ANNULÉ":
          return "badges bg-lightred"; // red
        case "EN_RETARD":
          return "badges bg-lightyellow"; // amber
        default:
          return "badges status-badge";
      }
    },

    // Localized (FR) label for payment status codes
    statusLabel(status) {
      const s = String(status || "").toUpperCase();
      switch (s) {
        case "PAID":
        case "PAYE":
        case "PAYÉ":
          return "Payé";
        case "UNPAID":
        case "IMPAYE":
        case "IMPAYÉ":
          return "Impayé";
        case "PARTIALLY_PAID":
        case "PARTIELLEMENT_PAYE":
        case "PARTIELLEMENT_PAYÉ":
          return "Partiellement payé";
        case "CANCELLED":
        case "ANNULE":
        case "ANNULÉ":
          return "Annulé";
        case "OVERDUE":
        case "EN_RETARD":
          return "En retard";
        default:
          // Fallback: Title-case the raw value replacing underscores
          return s
            .toLowerCase()
            .replace(/_/g, " ")
            .replace(/\b\w/g, (c) => c.toUpperCase());
      }
    },

    openEditModal(item) {
      this.selectedDevis = item;
    },

    // Print the current table view (filtered if a search is active) with logo + footer
    async printTable() {
      const rows = this.filteredData && this.filteredData.length ? this.filteredData : this.data;
      const win = window.open("", "_blank");
      if (!win) return;
      let logo = "";
      try { logo = await getCompanyLogoDataUrl('logo'); } catch (_) { /* ignore logo fetch */ }
      const c = this.company || {};
      const esc = (s) => String(s ?? '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
      const line1 = esc(c.name || '');
      const line2 = esc([c.address, c.code_postal].filter(Boolean).join(' | '));
      const line3 = esc([c.email, c.url].filter(Boolean).join(' | '));
      const taxBits = [];
      if (c.rc) taxBits.push(`RC: ${esc(c.rc)}`);
      if (c.if) taxBits.push(`IF: ${esc(c.if)}`);
      if (c.ice) taxBits.push(`ICE: ${esc(c.ice)}`);
      if (c.tp) taxBits.push(`TP: ${esc(c.tp)}`);
      if (c.cnss) taxBits.push(`CNSS: ${esc(c.cnss)}`);
      const line4 = taxBits.join(' | ');

      const html = `
        <html>
          <head>
            <title>Liste des Factures</title>
            <style>
              @page { size: A4 portrait; margin: 16mm; }
              body{font-family: Arial, Helvetica, sans-serif; margin:0;}
              .header{position:fixed; top:0; left:0; right:0; text-align:center; padding-top:6mm;}
              .header img{ max-height:40px; }
              .wrap{ margin: 60px 0 70px 0; }
              h3{ margin: 0 0 10px 0; }
              table{width:100%;border-collapse:collapse}
              th,td{border:1px solid #ccc;padding:6px;text-align:left;font-size:12px}
              thead th{background:#1E68A3;color:#fff}
              .footer{position:fixed; left:16mm; right:16mm; bottom:10mm; font-size:11px;}
              .page-num{position:fixed; right:16mm; bottom:6mm; color:#888; font-size:11px;}
            </style>
          </head>
          <body>
            <div class="header">${logo ? `<img src="${logo}" alt="logo"/>` : ''}</div>
            <div class="wrap">
              <h3>Liste des Factures</h3>
              <table>
                <thead>
                  <tr>
                    <th>Facture</th>
                    <th>Client</th>
                    <th>Date</th>
                    <th>Paiement</th>
                    <th>Déclarée</th>
                    <th>Total TTC</th>
                  </tr>
                </thead>
                <tbody>
                  ${rows.map(r => `
                    <tr>
                      <td>${esc(r.numero_facture || `FCT-${r.id}`)}</td>
                      <td>${esc(r.client_nom || "")}</td>
                      <td>${esc(r.date_creation || r.CreatedOn || "")}</td>
                      <td>${esc(r.Payment_Status || r.statut_paiement || "")}</td>
                      <td>${esc(r.declare_label || (r.declare ? "Déclarée" : "Non déclarée"))}</td>
                      <td>${r.montant_total != null ? esc(Number(r.montant_total).toFixed(2)) : ""}</td>
                    </tr>`).join("")}
                </tbody>
              </table>
            </div>
            <div class="footer">
              ${line1 ? `<div>${line1}</div>` : ''}
              ${line2 ? `<div>${line2}</div>` : ''}
              ${line3 ? `<div>${line3}</div>` : ''}
              ${line4 ? `<div>${line4}</div>` : ''}
            </div>
            <div class="page-num"></div>
          </body>
        </html>`;
      win.document.open();
      win.document.write(html);
      win.document.close();
      setTimeout(() => { try { win.focus(); win.print(); } catch(e){ /* ignore */ } }, 100);
    },

    // Refresh list from server and re-apply filters
    async refreshList() {
      try {
        await this.getFacturesData();
        this.applyFilters();
      } catch (e) {
        console.error(e);
      }
    },

    async getCompanyData() {
      try {
        const result = await getCompanyData();
        const data = result?.data ?? result;
        this.company = {
          id: data.id,
          name: data.societe_nom,
          address: data.adress,
          email: data.email,
          tel: data.telephone_entreprise,
          ice: data.ice,
          if: data.identifiant_fiscal,
          rc: data.rc,
          code_postal: data.code_postal,
          telephone_personnel: data.telephone_personnel,
          cin: data.cin,
          tp: data.tp,
          cnss: data.cnss,
          lieu_naissance: data.lieu_naissance,
          nom_complet_arabe: data.nom_complet_arabe,
          nom_complet_francais: data.nom_complet_francais,
          nom_banque: data.nom_banque,
          rib: data.rib,
          code_banque_swift: data.code_banque_swift,
          adresse_siege_social_francais: data.adresse_siege_social_francais,
          webesite: data.webesite,
        url: data.url,
        capital: data.capital,
        logo: data.logo,
        logo_small: data.logo_small,
        created_at: data.created_at,
      };
      } catch (error) {
        console.error(error);
        toast.error(error.response.data.message);
        toast.error(error.response.data.error);
      }
    },

    async handlePdf(devis) {
      const clientData = this.findClient(devis.client_id);
      // const logoBase64 = await this.getBase64ImageFromUrl(
      //   `${process.env.VUE_APP_URL}storage/${this.company.logo_small}`
      // );
      // Removed unused local variables

      const products = [];
      try {
        const data = await getLignesCommandeDataByCommandeId(devis.commande_id);
        data.forEach((item) => {
          const t = item.item_data && (item.item_data.taux_tva ?? item.item_data.taux_taxe);
          const derived = item.montant_HT ? ((item.montant_TTC / item.montant_HT - 1) * 100) : 0;
          const tax = Number((t ?? derived).toString().replace(',', '.')) || 0;
          products.push({
            nameProduct: item.item_data ? item.item_data.nom : item.nom_libre,
            quantity: item.quantite,
            unit_price: item.prix_unitaire,
            tax,
            PTHT: item.montant_HT,
          });
        });
      } catch (error) {
        const message =
          error?.response?.data?.message ||
          error?.response?.data?.error ||
          error?.message ||
          "Impossible de récupérer les lignes de la commande.";
        toast.error(message);
        return;
      }
      const mockCommand = {
        type: "facture",
        nameClient: clientData.nom + " " + clientData.prenom,
        emailClient: clientData.email,
        adressClient: clientData.adresse,
        PhoneClient: clientData.telephone,
        date_created: devis.date_creation,
        Nbdevis: devis.numero_facture,
        client_id: devis.client_id,
        commande_id: devis.commande_id,
        terms_payment: devis.mode_paiement,
        line: products,
        notes: devis.notes,
      };

      let logoSmall = "";
      try {
        logoSmall = await getCompanyLogoDataUrl('logo');
      } catch (_) { /* ignore logo load errors */ }

      const mockCompanyInfo = {
        logoSmall,
        name: this.company.name,
        address: this.company.address,
        postalCode: this.company.code_postal,
        email: this.company.email,
        website: this.company.url,
        companyLegalName: this.company.name,
        capital: this.company.capital,
        bankInfo: {
          name: this.company.nom_banque,
          rib: this.company.rib,
        },
        socialInfo: {
          address: this.company.adresse_siege_social_francais,
          phone: this.company.telephone_personnel,
          email: this.company.email,
          website: this.company.url,
        },
        taxId: {
          rc: this.company.rc,
          if: this.company.if,
          tp: this.company.tp,
          cnss: this.company.cnss,
          ice: this.company.ice,
        },
      };
      const mockfontData = {
        Roboto: {
          normal:
            "https://www.google.com/search?q=http://example.com/fonts/Roboto-Regular.ttf",
          bold: "https://www.google.com/search?q=http://example.com/fonts/Roboto-Bold.ttf",
          italics:
            "https://www.google.com/search?q=http://example.com/fonts/Roboto-Italic.ttf",
          bolditalics:
            "https://www.google.com/search?q=http://example.com/fonts/Roboto-BoldItalic.ttf",
        },
      };
      try {
        generateCommandPdf(mockCommand, mockCompanyInfo, mockfontData);
      } catch (error) {
        console.error("PDF generation failed:", error);
      }
    },

    async exportPDF() {
      const rows = this.filteredData.length ? this.filteredData : this.data;
      if (!rows || !rows.length) return;
      const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const headerHeight = 26;
      const margin = 12;

      let logo = null;
      try { logo = await getCompanyLogoDataUrl('logo'); } catch (e) { /* ignore */ }
      const drawHeader = () => {
        if (!logo) return;
        const w = 30, h = 12, x = (pageWidth - w) / 2, y = 8;
        try {
          const fmt = logo.startsWith('data:image/png') ? 'PNG' : 'JPEG';
          doc.addImage(logo, fmt, x, y, w, h);
        } catch (_) { /* ignore */ }
      };
      const drawFooter = () => {
        const c = this.company || {};
        const leftX = margin;
        let y = pageHeight - 22; // leave some space above bottom
        const maxWidth = pageWidth - 2 * margin;
        const lineHeight = 4.2;
        doc.setFontSize(9);
        const write = (text) => {
          if (!text) return;
          const wrapped = doc.splitTextToSize(String(text), maxWidth);
          wrapped.forEach((ln) => { doc.text(ln, leftX, y); y += lineHeight; });
        };

        const line1 = c.name ? String(c.name) : '';
        const line2 = [c.address, c.code_postal].filter(Boolean).join(' | ');
        const line3 = [c.email, c.url].filter(Boolean).join(' | ');
        const taxBits = [];
        if (c.rc) taxBits.push(`RC: ${c.rc}`);
        if (c.if) taxBits.push(`IF: ${c.if}`);
        if (c.ice) taxBits.push(`ICE: ${c.ice}`);
        if (c.tp) taxBits.push(`TP: ${c.tp}`);
        if (c.cnss) taxBits.push(`CNSS: ${c.cnss}`);
        const line4 = taxBits.join(' | ');

        write(line1);
        write(line2);
        write(line3);
        write(line4);
      };

      const body = rows.map((r) => [
        r.numero_facture || `FCT-${r.id}`,
        r.client_nom || '-',
        r.date_creation || r.CreatedOn || '-',
        r.statut_paiement || '-',
        r.declare_label || (r.declare ? 'Déclarée' : 'Non déclarée'),
        r.montant_total != null ? Number(r.montant_total).toFixed(2) + ' MAD' : '-',
      ]);

      const startY = headerHeight + 12;
      autoTable(doc, {
        startY,
        head: [[ 'Facture', 'Client', 'Date', 'Paiement', 'Déclarée', 'Total TTC' ]],
        body,
        headStyles: { fillColor: [30, 104, 163], textColor: 255, fontStyle: 'bold', fontSize: 9, halign: 'center' },
        styles: { fontSize: 8, cellPadding: 3, overflow: 'linebreak', cellWidth: 'wrap' },
        columnStyles: {
          0: { cellWidth: 28 },
          1: { cellWidth: 50 },
          2: { cellWidth: 26, halign: 'center' },
          3: { cellWidth: 26, halign: 'center' },
          4: { cellWidth: 26, halign: 'center' },
          5: { cellWidth: 26, halign: 'right' },
        },
        alternateRowStyles: { fillColor: [245, 245, 245] },
        didDrawPage: () => {
          drawHeader();
          drawFooter();
          const pageCount = doc.internal.getNumberOfPages();
          const currentPage = doc.internal.getCurrentPageInfo().pageNumber;
          doc.setFontSize(9); doc.setTextColor(120);
          doc.text(`Page ${currentPage} sur ${pageCount}`, pageWidth - margin, pageHeight - 6, { align: 'right' });
          doc.setTextColor(0);
        },
        margin: { left: margin, right: margin, top: startY, bottom: 26 },
      });

      const timestamp = new Date().toISOString().slice(0, 10);
      const filename = `factures_${timestamp}.pdf`;
      doc.save(filename);
    },

    exportCSV() {
      const rows = this.filteredData.length ? this.filteredData : this.data;
      if (!rows || !rows.length) return;
      const headers = ['Facture','Client','Date','Paiement','Déclarée','Total TTC'];
      const csv = [
        headers.join(','),
        ...rows.map(r => [
          r.numero_facture || `FCT-${r.id}`,
          r.client_nom || '',
          r.date_creation || r.CreatedOn || '',
          r.statut_paiement || '',
          r.declare_label || (r.declare ? 'Déclarée' : 'Non déclarée'),
          r.montant_total != null ? r.montant_total : ''
        ].map(v => `"${String(v).replace(/"/g,'""')}"`).join(','))
      ].join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; a.download = `factures_${new Date().toISOString().slice(0,10)}.csv`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a); URL.revokeObjectURL(url);
    },
  },
  async mounted() {
    const user = getCurrentUser();
    this.currentUser = user;
    this.isAdmin = String(user?.role || "").toLowerCase() === "admin";
    await this.getClientsData();
    await this.getFacturesData();
    await this.getCompanyData();
    this.applyFilters();
  },
};
</script>

<style scoped>
.declare-select {
  min-width: 140px;
}

.page-loading-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  z-index: 10;
}

.page-wrapper.sales-list {
  position: relative;
}

.dashboard-spinner {
  width: 48px;
  height: 48px;
}
</style>
